module.exports = __webpack_public_path__ + "static/media/aboutus-1 1.97447a22.png";